import { loadModules } from 'esri-loader';
import GeometryHelper from '../helpers/GeometryHelper';

export default class ClientsideLocations {
  constructor(props) {
    this.props = props;
  }

  async getLocations(featureLayer) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);
    const query = new Query();
    query.where = this.props.where;
    query.returnDistinctValues = true;
    query.returnGeometry = false;
    query.outFields = new Array(this.props.stateField, this.props.countryField);

    const response = await featureLayer.queryFeatures(query);
    const locationData =
      response.features && response.features.length > 0
        ? response.features.map((f) => {
          return {
            state: f.attributes[this.props.stateField],
            country: f.attributes[this.props.countryField]
          };
        })
        : null;
    return locationData;
  }

  async getLocationInfoByName(
    featureLayer,
    name,
    factsheetLinkField,
    factoids
  ) {
    const [Query, Extent] = await loadModules([
      'esri/tasks/support/Query',
      'esri/geometry/Extent'
    ]);
    const query = new Query();
    query.where = `LOWER(${this.props.stateField}) = LOWER('${name}')`;
    query.returnGeometry = true;

    const outFields = new Array(this.props.stateField, factsheetLinkField);
    if (factoids) {
      factoids.forEach((f) => {
        outFields.push(f.field);
      });
    }
    query.outFields = outFields;

    const response = await featureLayer.queryFeatures(query);
    const resultValue = response.features
      ? response.features[0].attributes[this.props.stateField]
      : null;
    const factsheetLinkValue =
      response.features && response.features[0].attributes[factsheetLinkField]
        ? response.features[0].attributes[factsheetLinkField]
        : '';
    const updatedFactoids = [];
    if (factoids && response.features) {
      factoids.forEach((f) => {
        updatedFactoids.push({
          field: f.field,
          label: f.label,
          text: f.text,
          format: f.format,
          value: response.features[0].attributes[f.field]
        });
      });
    }

    let resultExtent;
    if (
      resultValue &&
      this.props.extentOverrides &&
      this.props.extentOverrides.filter(
        (e) => e.name.toLowerCase() == resultValue.toLowerCase()
      ).length > 0
    ) {
      const resultExtentJson = this.props.extentOverrides.filter(
        (e) => e.name.toLowerCase() == resultValue.toLowerCase()
      )[0].extent;
      resultExtent = new Extent(resultExtentJson);
    } else {
      resultExtent = await GeometryHelper.getExtentOfAllFeatures(
        response.features
      );
      resultExtent.expand(this.props.extentExpandFactor);
    }

    return resultValue
      ? {
        name: resultValue,
        factsheetLink: factsheetLinkValue,
        updatedFactoids: updatedFactoids,
        extent: resultExtent
      }
      : null;
  }

  async getLocationData(location, featureLayer) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);
    const query = new Query();
    query.where = this.props.stateField + " = '" + location + "'";
    query.outFields = '*';

    const response = await featureLayer.queryFeatures(query);
    // console.warn('Location Data Response');
    // console.warn(response);
    return response.features && response.features.length > 0
      ? response.features[0].attributes
      : null;
  }

  async getLocationNameByGeometry(featureLayer, mapPoint) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);
    const query = new Query();
    query.where = this.props.where;
    query.returnGeometry = false;
    query.geometry = mapPoint;
    query.outFields = new Array(this.props.stateField, this.props.facilitiesField);

    const response = await featureLayer.queryFeatures(query);
    return response.features && response.features.length > 0
      ? response.features[0].attributes[this.props.stateField]
      : null;
  }
}
